import React from 'react';
import styles from './AppFieldLine.module.css';

interface AppFieldLineProps {
  error?: boolean;
  className?: string;
}

const AppFieldLine: React.FC<AppFieldLineProps> = ({ error = false, className = '' }) => {
  const classNames = [styles.line, error ? styles.lineError : '', className]
    .filter(Boolean)
    .join(' ');

  return <div className={classNames} aria-hidden="true" />;
};

export default AppFieldLine;
